import React from 'react'
import styled from '@emotion/styled'
import { Skeleton } from '@bbl-digital/snorre'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, 50px);
  grid-row-gap: 0;
  align-items: center;
  padding-left: 1em;
  font-size: 13px;
  opacity: 0.2;
`

const SkeletonRow = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  grid-column-gap: 10px;
`

interface IProps {}

const MenuLoading: React.FC<IProps> = (props) => {
  return (
    <Wrapper>
      {[1, 2, 3, 4].map((i) => (
        <SkeletonRow key={i}>
          <Skeleton width="16px" height="16px" />
          <Skeleton height="16px" />
        </SkeletonRow>
      ))}
    </Wrapper>
  )
}

export default MenuLoading
